import { MaskLines, Reveal } from "../components/anim";
import { Eyebrow } from "../components/ui-bits";
import GalleryGrid from "../components/GalleryGrid";
import useSEO from "../hooks/useSEO";

export default function Gallery() {
  useSEO(
    "Gallery: allestimenti, eventi e attrezzature | Sprizziamoci",
    "La gallery Sprizziamoci: allestimenti wedding, feste private, eventi aziendali, manifestazioni e attrezzature. Immagini filtrabili per categoria."
  );
  return (
    <article data-testid="gallery-page">
      <section className="pt-32 md:pt-44 pb-14">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <Eyebrow>Gallery</Eyebrow>
          <MaskLines
            lines={["UN BANCO.", "MILLE OCCASIONI", "PER BRINDARE."]}
            as="h1"
            when="load"
            delay={0.15}
            lineClass="font-display font-semibold tracking-tight leading-[1] text-[clamp(2.6rem,6.5vw,5.5rem)]"
            className="mt-6"
          />
          <Reveal delay={0.3}>
            <p className="mt-8 max-w-2xl text-sm md:text-base leading-relaxed text-white/50 italic">
              Immagini illustrative del concept. Le foto degli eventi realizzati arrivano a breve.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <GalleryGrid />
        </div>
      </section>
    </article>
  );
}
